const Document = ({ size=24, color="#000000", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
    >
        <path d="M6.75 6V1.75A1 1 0 0 1 7.75.75h9.69l5.81 5.86v15.64a1 1 0 0 1-1 1H7.75a1 1 0 0 1-1-1V6Z" />

        {/* Folded corner */}
        <path d="M17.23.77v4.99a1 1 0 0 0 1 1h4.99" />

        {/* Text lines */}
        <path d="M9 10.5h10" />
        <path d="M9 14.5h10" />
        <path d="M9 18.5h7" />
    </svg>
);

export default Document;
